var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/jsx-max-depth */
import { ThemeProvider } from '@wise/components-theming';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import TapestryCard from '../common/tapestrycard/TapestryCard';
import styles from './ComparisonSelfServe.module.less';
import ComparisonSelfServeBreakdown from './ComparisonSelfServeBreakdown/ComparisonSelfServeBreakdown';
import ComparisonSelfServeForm from './ComparisonSelfServeForm/ComparisonSelfServeForm';
import { compareProvider } from './api/compareProvider';
const ComparisonSelfServe = ({ initialSourceCurrencyCode, initialTargetCurrencyCode, routes, currencies, formResultCallback, trackEvent, inverseHeader = false, }) => {
    const [feeBreakdown, setFeeBreakdown] = useState();
    const [isError, setIsError] = useState(false);
    const handleFormSubmit = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const comparison = yield compareProvider(formData);
            setFeeBreakdown(comparison);
            if (formResultCallback) {
                formResultCallback(comparison);
            }
        }
        catch (error) {
            setIsError(true);
            console.error(error);
        }
    });
    if (feeBreakdown) {
        return (_jsx(ComparisonSelfServeBreakdown, { data: feeBreakdown, trackEvent: trackEvent, inverseHeader: inverseHeader }));
    }
    return (_jsxs("div", Object.assign({ className: styles.selfServe__wrapper }, { children: [_jsx(TapestryCard, { children: _jsx(ThemeProvider, Object.assign({ theme: "personal" }, { children: _jsx("div", Object.assign({ className: styles.selfServe__container }, { children: _jsx(ComparisonSelfServeForm, { initialSourceCurrencyCode: initialSourceCurrencyCode, initialTargetCurrencyCode: initialTargetCurrencyCode, routes: routes, currencies: currencies, handleSubmit: (data) => handleFormSubmit(data), isError: isError }) })) })) }), _jsx("div", { children: _jsx("p", Object.assign({ className: `text-xs-center m-t-5 ${styles.selfServe__footer}` }, { children: _jsx(FormattedMessage, { id: "self-serve.form.footer.info" }) })) })] })));
};
export default ComparisonSelfServe;
